import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TaskViewModel } from '../../../models-views/task.view.model';
import { ConsoleViewModel } from '../../../models-views/console.view.modal';

@Component({
  selector: 'app-cpd-tasks',
  standalone: false,
  templateUrl: './cpd-tasks.component.html',
  styleUrl: './cpd-tasks.component.scss'
})
export class CpdTasksComponent {
  page:number = 1;
  page_size:number = 300;
  listOfTaskStatus:any = []
  listOfPriority:any  = []
  listOfTasks:any = []
  userlist:any = []
  @Input('data') data:any
  @Output() openTaskDetailEvent = new EventEmitter<any>();
  

  constructor( private router:Router,    private vmt : TaskViewModel, private cvm : ConsoleViewModel){
     
    this.vmt.taskStatusList.subscribe(data => {
      this.listOfTaskStatus = data.results
    })

    this.vmt.priorityList.subscribe(data => {
      this.listOfPriority = data.results
    })
   

    this.cvm.ProjecttaskDataList.subscribe(data => {
      this.listOfTasks = data.results
    })
    
  }

ngOnInit(): void {
  //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  //Add 'implements OnInit' to the class.
  
  this.vmt.getPriorityList(this.page,this.page_size)
  this.vmt.getTaskStatusList(this.page,this.page_size)
 
}

ngOnChanges(changes: SimpleChanges): void {
  //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
  //Add '${implements OnChanges}' to the class.
  if(this.data && changes['data'].currentValue){
    this.cvm.getTaskList(this.page,this.page_size,this.data,'project')
  }
}

formatIdToFourDigits(id: number, str: string): string {
  return id ? str+ id.toString().padStart(4, '0') : '';
}


getNameById(id:number){
  return id ? this.userlist.filter(e => e.id == id)[0].name : ''
}
  
  getPriorityColor(priority: string): string {
    switch (priority) {
      case 'High': return 'red';
      case 'Medium': return 'orange';
      case 'Low': return 'blue';
      default: return 'default';
    }
  }

  getStatusColor(status: number): string {
    if(this.listOfTaskStatus){
        return status ?  this.listOfTaskStatus.filter( e => e.id == status)[0].hexcolor : 'default';
    } else {
      return 'default';
    }
  }
 

  getTaskPriorityName(id:number){
    if(this.listOfPriority){
      return id ? this.listOfPriority.filter(e => e.id == id )[0]?.name : '';
    }
   }


  openTaskDetailModal(task: any){
    this.openTaskDetailEvent.emit(task);
  }


}
